import { render, staticRenderFns } from "./LogoAnimated.vue?vue&type=template&id=4fa8ddba&scoped=true&"
import script from "./LogoAnimated.vue?vue&type=script&lang=js&"
export * from "./LogoAnimated.vue?vue&type=script&lang=js&"
import style0 from "./LogoAnimated.vue?vue&type=style&index=0&id=4fa8ddba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8ddba",
  null
  
)

export default component.exports